import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import {
  menu1,
  menu2,
  mobileMenu1,
  mobileMenu2,
  mobileMenu3,
  mobileMenu4,
} from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mb="20px" mt="-15px" bg="black" column center>
          <CFImage src={mobileMenu1} w="100%" alt="Food Gallery" />
          <CFImage src={mobileMenu2} w="100%" alt="Food Gallery" />
          <CFImage src={mobileMenu3} w="100%" alt="Food Gallery" />
          <CFImage src={mobileMenu4} w="100%" alt="Food Gallery" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" m="0 auto" mt="-5px">
          <CFImage src={menu1} w="100%" alt="Food Gallery" />
          <CFImage src={menu2} w="100%" alt="Food Gallery" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
